
// 时间格式转换时间戳
export function format_datetime_to_timestamp(value) {
    if (value === '' || value == null) {
        return value
    }
    let stamp = new Date(value).getTime()
    return stamp + ''
}

// 时间戳转换成格式化日期
export function format_timestamp_to_DateTime(timestamp, format = 'yyyy-MM-dd') {
    // 先把年 日 小时 不重复的字母转成正确格式
    format = format.replace(/[Y]/g, 'y').replace(/[D]/g, 'd').replace(/[h]/g, 'H')

    // MM表示月份 mm表示分钟 都为字母m 作区分
    format = format.replace(/-mm/g, '-MM').replace(/mm-/g, 'MM-')
    format = format.replace(/:MM/g, ':mm').replace(/MM:/g, 'mm:')
    return dateFormat(timestamp, format)
}

const dateFormat = function (timestamp, fmt = 'yyyy-MM-dd') {
    if (!timestamp) {
        return ''
    }
    let date = new window.Date(Number(timestamp))
    var o = {
        'y': date.getFullYear(), // 年份，注意必须用getFullYear
        'M': date.getMonth() + 1, // 月份，注意是从0-11
        'd': date.getDate(), // 日期
        'q': Math.floor((date.getMonth() + 3) / 3), // 季度
        'w': ['日', '一', '二', '三', '四', '五', '六'][date.getDay()], // 星期，注意是0-6
        'H': date.getHours(), // 24小时制
        'h': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // 12小时制
        'm': date.getMinutes(), // 分钟
        's': date.getSeconds(), // 秒
        'S': date.getMilliseconds() // 毫秒
    }
    for (var i in o) {
        fmt = fmt.replace(new RegExp(i + '+', 'g'), function (m) {
            var val = o[i] + ''
            if (i === 'w') return val
            // 补0
            for (var j = 0, len = val.length; j < m.length - len; j++) val = '0' + val
            // 截取
            return m.length === 1 ? val : val.substring(val.length - m.length)
        })
    }
    return fmt
}